// Version : 1.0.0
// Author : AGALYA

import PassbookChequeDetailsActionType from './passbook-cheque-details.types';

/** ***************** PassbookCheque Update Start ************************/
export const updatePassbookChequeStart = (passbookChequeCredentials: any) => ({
	type: PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_START,
	payload: passbookChequeCredentials,
});

export const updatePassbookChequeSuccess = (passbookChequeSuccess: any) => ({
	type: PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_SUCCESS,
	payload: passbookChequeSuccess,
});

export const updatePassbookChequeFailure = (passbookChequeFailure: any) => ({
	type: PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_FAILURE,
	payload: passbookChequeFailure,
});

export const updatePassbookChequeResponseResetStart = () => ({
	type: PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_RESPONSE_REST_START,
});

export const updatePassbookChequeResponseChanged = () => ({
	type: PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_RESPONSE_CHANGED,
});
/** ***************** PassbookCheque Update End ************************/
